import {ORDER_SOURCE} from 'src/data/enums/order';
import {FilterAutoCompleteOptions} from 'src/view/components/filters/AutoComplete/AutoComplete';

export const orderSourceOptions: FilterAutoCompleteOptions = Object.keys(ORDER_SOURCE).map(
    (source) => ({
        value: source,
        label: source,
    })
);
